import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Navigation(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M19.662 4.338L4.93 9.768l6.183 2.21a1.5 1.5 0 01.907.908l2.21 6.183 5.43-14.73zm.325-2.251c1.201-.443 2.37.725 1.926 1.926l-6.282 17.04c-.485 1.316-2.348 1.306-2.82-.014l-2.593-7.257L2.96 11.19c-1.32-.472-1.329-2.335-.014-2.82l17.041-6.282z",
    clipRule: "evenodd"
  }));
}

export default Navigation;